import axios from "axios";
const debounce = require('debounce');
import React, { useEffect, useState, useRef } from "react";
import dispatch from "../../components/dispatch";
const AddressFinderField = (props) => {
  const [abController, setABController] = useState(null);
  const [value, setValue] = useState(props.value);
  const [results, setResults] = useState();
  const [show, setShow] = useState(true);
  const token = document.querySelector('meta[name="nzp_token"]')?.getAttribute('value');
  const [loading, setLoading] = useState(false);
  const isAu = props.isAu;
  const wrapperRef = useRef(null);

  useEffect(() => {
    setValue(props.value || '');
  }, [props.value]);

  const abortController = () => {
    let controller = abController;
    if (controller) controller.abort();
    controller = new AbortController();
    setABController(controller);
    return controller;
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShow(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleNzAddress = async (record, controller) => {
    try {
      const response = await axios.get(
        `https://api.nzpost.co.nz/parceladdress/2.0/domestic/addresses/${record.address_id}`,
        {
          signal: controller.signal,
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );
      const nzAddress = response.data.address;
      if (nzAddress) {
        props.onSelect?.(nzAddress);
        if (props.dom) dispatch('ADDRESS_SELECTED', nzAddress);
        setValue(record.full_address);
      }
    } catch (err) {
      console.error('NZ address fetch failed', err);
    }
  };

  const handleAuAddress = (record) => {
    const address1 = [
      record.floor || '',
      record.street_number || '',
      record.route || ''
    ]
      .filter(Boolean)
      .join(' ')
      .replace(/\s+/g, ' ')
      .trim();
    const normalized = {
      ...record,
      street: record.route,
      street_type: '',
      street_number: record.street_number,
      address2: record.suburb,
      city: record.city,
      postcode: record.postcode,
      country: record.country,
      address1,
    };
    props.onSelect?.(normalized);
    if (props.dom) dispatch('ADDRESS_SELECTED', normalized);
    setValue(`${address1}, ${record.suburb}, ${record.city}, ${record.state} ${record.postcode}`);
  };

  const handleOnClick = (record) => {
    const controller = abortController();
    if (isAu) {
      handleAuAddress(record);
    } else {
      handleNzAddress(record, controller);
    }
    setShow(false);
  };

  const searchNzAddresses = async (param, controller) => {
    try {
      const response = await axios.get(
        'https://api.nzpost.co.nz/parceladdress/2.0/domestic/addresses',
        {
          params: {
            q: param,
            count: 6
          },
          signal: controller.signal,
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );
      if (response.data?.addresses) {
        setResults(response.data.addresses);
      }
    } catch (err) {
      console.error('NZ search failed', err);
    }
  };

  const searchAuAddresses = async (param, controller) => {
    setLoading(true);
    try {
      const response = await axios.get('/api/places/getplaces', {
        params: { param },
        signal: controller.signal
      });
      const res = response.data;
      if (Array.isArray(res) && res.length) {
        setResults(res);
      }
    } catch (err) {
      console.error('AU search failed', err);
    } finally {
      setLoading(false);
    }
  };

  const triggerSearch = (param) => {
    if (param && param.length >= 4) {
      setShow(true);
      const controller = abortController();
      isAu ? searchAuAddresses(param, controller) : searchNzAddresses(param, controller);
    }
  };

  return (
    <div className={'address-field'} ref={wrapperRef}>
      <input
        type={'text'}
        autoComplete={'none'}
        placeholder='Start typing your address'
        value={value}
        onChange={(e) => {
          const inputValue = e.target.value;
          setValue(inputValue);
          props.onChanged?.(inputValue);
        }}
        onKeyUp={debounce((e) => {
          triggerSearch(e.target.value);
        }, 100)}
      />
      {show && (
        <div className={'address-field__dropdown'}>
          {loading ? (
            <div className="custom-spinner">
              <div className="custom-spinner__spinner" />
            </div>
            ) : results && results.length ? (
            <ul>
            {results.map((result, index) => (
              <li key={index} onClick={() => handleOnClick(result)}>
                {result.full_address}
              </li>
            ))}
          </ul>
            ) : null}
        </div>
      )}
    </div>
  );
};
export default AddressFinderField;
